import { makeStyles } from '@material-ui/core';

export default makeStyles(
  (theme) => ({
    root: {
      position: 'absolute',
      zIndex: 1,
      top: '-10000px',
      left: '-10000px',
      transition: `opacity 0.2s ${theme.transitions.easing.easeIn}`,
      opacity: 0,
    },
  }),
  {
    name: 'HoveringToolbar',
  }
);
